import React, { useState } from 'react';
import '../../Home.scss';
import './WellnessLeader.scss'
import { Link } from 'react-router-dom';
import { useFlags } from 'launchdarkly-react-client-sdk';

const WellnessLeader: React.FC = () => {

    const { showDeprecationNotice } = useFlags();
    const { showConsumerApiUiChanges } = useFlags();

   const [showBanner, setShowBanner] = useState<boolean>(true)
   
    const BASE_URL = process.env.REACT_APP_BASE_URL;
    //const deprecationLink = `${BASE_URL}PublicDocumentation/V6#deprecation-notice`; 
    const deprecationLink = 'https://developers.mindbodyonline.com/ui/documentation/public-api#/http/mindbody-public-api-v6-0/developer-resources/deprecation-notice'
    
    const oncloseClick = () =>{
        setShowBanner(!showBanner)
    }

    return (
        <div className="section grow-section">
            {showDeprecationNotice && showBanner && 
                <div className="banner-notice d-flex justify-content-center">
                    <div className="d-flex justify-content-center align-items-center">
                        <span><i className="banner-warning"></i>Important Update: Deprecation of Public API 5.0 and 5.1 has been suspended. While support for these versions will continue, we encourage adoption of our newest version. To learn more, click  <a className="deprecation-banner-link" href={deprecationLink}> Deprecation notice</a>. </span>
                    </div>
                    <i onClick={oncloseClick} className="banner-close-button"></i> 
                </div>
            }
            <img className="hero2-light-div-sm">
            </img>
            <div className="hero2-text-wrap">
                <h1 className="h1-jumbo light" >Grow with the wellness leader.</h1>
                <div className="tagline light">
                    Mindbody offers you easy access to 50,000 wellness <br className="br-tag" />businesses and millions of consumers.

                        </div>
                {showConsumerApiUiChanges &&
                    <div className="wl-button-container">
                        <div className="herobtnwrapper">
                            <a id="btn-leader-srt-bld" href="PublicDocumentation/V6" className="strt-btn w-button btn-big btn-business">Start Building for Businesses</a>
                        </div>
                        <div className="herobtnwrapper consumer-btn-wrapper">
                            <a id="btn-leader-srt-bld" href="ConsumerDocumentation#consumer-api" className="strt-btn w-button btn-big btn-consumer">Start Building for Consumer</a>
                        </div>
                    </div>
                }
                {!showConsumerApiUiChanges &&
                    <div className="herobtnwrapper">
                        <a id="btn-leader-srt-bld" href="PublicDocumentation/V6" className="strt-btn w-button btn-big btn-business">Start Building for Businesses</a>
                    </div>
                }
            </div>
        </div>
    )
}

export default WellnessLeader;